import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store.js'
/* 引用组件element UI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

/* Bootstrap的引用 */
/* import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js' */

/* 使用组件element UI */
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js